export default __webpack_public_path__ + "media/images/jet-story-logo-175baae166452ce28927db026b67127a.png";